import { render, staticRenderFns } from "./bindApprovalTemplateDialog.vue?vue&type=template&id=4a630d0f&scoped=true&"
import script from "./bindApprovalTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./bindApprovalTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a630d0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a630d0f')) {
      api.createRecord('4a630d0f', component.options)
    } else {
      api.reload('4a630d0f', component.options)
    }
    module.hot.accept("./bindApprovalTemplateDialog.vue?vue&type=template&id=4a630d0f&scoped=true&", function () {
      api.rerender('4a630d0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/bindApprovalTemplateDialog.vue"
export default component.exports